<template>
    <social-nav :items="items" @item-click="share">
        {{ data.label }}
    </social-nav>
</template>

<script>
import Share from '@/foo/utils/Share'
import SocialNav from './SocialNav'
export default {
    name: 'SocialShare',
    props: {
        url: {
            type: String,
            required: true,
        },
    },
    components: {
        SocialNav,
    },
    data: () => ({
        items: [
            {
                id: 'facebook',
                iconId: 'icon-facebook',
            },
            {
                id: 'twitter',
                iconId: 'icon-twitter',
            },
        ],
    }),
    methods: {
        share(id) {
            if (id === 'facebook') this.facebookShare()
            if (id === 'twitter') this.twitterShare()
        },
        facebookShare() {
            const { url } = this
            Share.facebook(url)
        },
        twitterShare() {
            const { url, data } = this
            Share.twitter(url, data.twitter)
        },
    },
    computed: {
        data() {
            const { $store } = this
            return $store.getters.data.share
        },
    },
}
</script>

<style src="styles/components/SocialShare.styl" lang="stylus"></style>


// WEBPACK FOOTER //
// src/app/components/SocialShare.vue